import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import * as serviceWorker from './serviceWorker';
import './index.css';
import App from './App';

const VERCEL_LIVE_FEEDBACK_SELECT_NODE =
  /Failed to execute 'selectNode' on 'Range': the given Node has no parent/;

/** Drop Vercel Live Feedback DOM snapshot noise (Sentry issue 7508408252 on /typeset). */
function isVercelLiveFeedbackSelectNodeError(event) {
  const value = event.exception?.values?.[0]?.value ?? '';
  if (!VERCEL_LIVE_FEEDBACK_SELECT_NODE.test(value)) {
    return false;
  }
  const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? [];
  return frames.some((frame) => frame.filename?.includes('/_next-live/feedback/'));
}

// Only initialize Sentry in production, not in local dev or Vite dev server
if (!import.meta.env.DEV && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    // https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-before-send
    beforeSend(event) {
      if (isVercelLiveFeedbackSelectNodeError(event)) {
        return null;
      }
      return event;
    },
  });
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
//serviceWorker.register();
